module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "theme": "light",
      "router": true,
      "mode": "horizontal"
    }
  }, [_c('li', {
    staticClass: "el-submenu",
    staticStyle: {
      "width": "80px",
      "height": "60px"
    }
  }), _vm._v(" "), _vm._l((_vm.routeList), function(item, index) {
    return (_vm.permissions.includes(item.meta.authorize)) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": ("" + (index+1))
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((_vm.childrenMenu(item.children)), function(children, i) {
      return (_vm.permissions.includes(children.meta.authorize)) ? _c('el-menu-item', {
        key: i,
        attrs: {
          "index": ((item.path) + "/" + (children.path))
        }
      }, [_vm._v("\n        " + _vm._s(children.name) + "\n      ")]) : _vm._e()
    })], 2) : _vm._e()
  }), _vm._v(" "), _c('el-submenu', {
    staticClass: "user",
    attrs: {
      "index": "0"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "logout",
    attrs: {
      "index": "0-1"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("logout")])], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3800c1b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 665
// module chunks = 14